<div data-test="hRtop_Vt" class="filters-h filters-h_toolbox-top mb-1">
  <div data-test="1o7puuKl" class="row align-items-center flex-nowrap">
    <div data-test="ZXfFmHLR" class="col">
      <div data-test="XkiYT9Lx" class="filters-h__items">
        <md-filter-dropdown
          data-test="fqGUt4cA"
          *ngFor="let filter of activeFilters; trackBy: trackControl"
          [filter]="filter"
          (removeFilter)="onRemoveFilter($event)"
          (resetFilter)="onResetFilter($event)"
          (toggleFilterOption)="onToggleFilterOption($event)"
          (searchFilterOptions)="onSearchFilterOptions($event)"
          (rangeFilterChange)="onRangeFilterChange($event)"
        ></md-filter-dropdown>
        <ng-container *ngIf="numInactiveFilters > 0">
          <div
            data-test="RDJ6ou3K"
            class="filters-h__item"
            (mdOutsideClick)="hideSearchedFilters()"
          >
            <button
              data-test="i2ym1bVh"
              (click)="toggleSearchedFiltersVisibility()"
              class="button button_sm button_secondary"
            >
              <span data-test="BbXkK0XQ" class="button__icon button__icon_left">
                <i data-test="kh9KIuVa" class="material-icons md-18">add</i>
              </span>
              <span data-test="4M6375rZ">Add filter</span>
            </button>
            <div
              data-test="mBYX7E46"
              [class.show]="searchedFiltersVisible"
              [class.active]="searchedFiltersVisible"
              class="dropdown dropdown_bottom-middle dropdown_arrow dropdown_filter dropdown_static"
            >
              <div data-test="GdSMAlNC" class="dropdown__wrap">
                <div
                  data-test="KoO4j7rg"
                  class="dropdown__search dropdown__search_prepend"
                >
                  <div data-test="RxZOHVBY" class="dropdown__search-prepend">
                    <div data-test="1qCvhTUp" class="icon">
                      <svg
                        data-test="UvoPn3dE"
                        class="icon__icon-search"
                        width="18px"
                        height="17.5px"
                      >
                        <use xlink:href="#icon-search"></use>
                      </svg>
                    </div>
                  </div>
                  <input
                    data-test="-LFFnC20"
                    #searchInput
                    (keyup)="onSearchFilters(searchInput.value)"
                    [value]="filtersSearchQuery"
                    class="dropdown__input input input_xs"
                    placeholder="Search ..."
                    type="text"
                  />
                </div>
                <ul data-test="zwPn98FK" class="dropdown__menu" data-simplebar>
                  <li
                    data-test="VrhyBTfV"
                    *ngFor="let searchedFilter of searchedFilters"
                    (click)="onAddFilter(searchedFilter)"
                    class="dropdown__menu-item"
                  >
                    <a data-test="0IoGsWY5" class="dropdown__menu-link">
                      {{ searchedFilter.defaultLabel }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div data-test="ohKZJRv8" class="col-auto">
      <button
        data-test="Owm3hKoy"
        (click)="onResetAllFilters()"
        class="link link_text link_text-sm"
      >
        <span data-test="uQn700tU" class="button__icon button__icon_left icon icon_14">
          <svg data-test="t00OlECX" class="icon__icon-refresh" width="10px" height="11px">
            <use xlink:href="#icon-refresh"></use>
          </svg>
        </span>
        Reset All
      </button>
    </div>
  </div>
</div>
